module.exports = "/_next/static/images/Delivery@2x-68959d058be572ba534fa5b6e50bba33.png";